'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$$asyncApi = exports.getSetUUIDAsync = exports.getSetUUID = exports.localStorage = exports.chromeStorage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pubnub = require('pubnub');

var _pubnub2 = _interopRequireDefault(_pubnub);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _errors = require('./errors');

var _storage = require('./storage');

var _utilities = require('./utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'pubnub:uuid';
var ACCESS_DENIED_CATEGORY = 'PNAccessDeniedCategory';
var CLIENT_INIT_ARGS = ['subscribeKey', 'publishKey', 'cipherKey', 'authKey', 'logVerbosity', 'uuid', 'ssl', 'origin', 'presenceTimeout', 'heartbeatInterval', 'restore', 'keepAlive', 'keepAliveSettings', 'suppressLeaveEvents'];

function catchExpectedPubNubError(error) {
  // ExpectedPubNubError is thrown when apps wish to skip pubnub
  // connection and avoid errors bubbling to the console.
  if (!(error instanceof _errors.ExpectedPubNubError)) {
    return _q2.default.reject(error);
  }
}

function refreshAuthKey(client, resolveConfig) {
  resolveConfig().then(function (config) {
    client.setAuthKey(config.authKey);
    client.reconnect();
  }).catch(catchExpectedPubNubError).done();
}

function getSetUUIDAsync(storage, callback) {
  if (!storage[_storage.$$asyncApi]) {
    throw Error('Cannot use getSetUUIDAsync with a non-async storage adapter');
  }
  var cachedUUID = storage.get(STORAGE_KEY);
  storage.get(STORAGE_KEY, function (result) {
    if (!result) {
      var generatedUUID = _pubnub2.default.generateUUID();
      storage.set(STORAGE_KEY, generatedUUID, function () {
        callback(generatedUUID);
      });
      return;
    }
    callback(result);
  });
}

function getSetUUID() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _storage.localStorage;

  if (storage[_storage.$$asyncApi]) {
    throw Error('Cannot use getSetUUID with an async storage adapter');
  }
  var cachedUUID = storage.get(STORAGE_KEY);
  if (!cachedUUID) {
    var generatedUUID = _pubnub2.default.generateUUID();
    storage.set(STORAGE_KEY, generatedUUID);
    return generatedUUID;
  }
  return cachedUUID;
}

function createClient(opts, resolveConfig) {
  var client = new _pubnub2.default(_extends({}, (0, _utilities.pick)(opts, CLIENT_INIT_ARGS)));
  var _addListener = client.addListener;
  var _subscribe = client.subscribe;

  client.addListener = function (listener) {
    var _status = listener.status;
    listener.status = function (evt) {
      if (evt.category === ACCESS_DENIED_CATEGORY) {
        refreshAuthKey(client, resolveConfig);
        return;
      }
      if (_status) {
        _status(evt);
      }
    };
    _addListener.call(client, listener);
    return client;
  };

  client.subscribe = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _subscribe.apply(client, args);
    return client;
  };

  return client;
}

function hydrateUUID(storage) {
  return function (config) {
    var deferred = _q2.default.defer();
    if (!storage[_storage.$$asyncApi]) {
      deferred.resolve(_extends({
        uuid: getSetUUID(storage)
      }, config));
    } else {
      getSetUUIDAsync(storage, function (uuid) {
        deferred.resolve(_extends({
          uuid: uuid
        }, config));
      });
    }
    return deferred.promise;
  };
}

exports.chromeStorage = _storage.chromeStorage;
exports.localStorage = _storage.localStorage;
exports.getSetUUID = getSetUUID;
exports.getSetUUIDAsync = getSetUUIDAsync;
exports.$$asyncApi = _storage.$$asyncApi;

exports.default = function (resolveConfig) {
  var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _storage.localStorage;

  if (typeof resolveConfig !== 'function') {
    throw Error('resolveConfig must be a function.');
  }

  var config = resolveConfig();
  if (typeof config.then !== 'function') {
    throw Error('resolveConfig must return a Promise.');
  }

  return config.then(hydrateUUID(storage)).then(function (opts) {
    return {
      client: createClient(opts, resolveConfig),
      config: opts
    };
  }).catch(catchExpectedPubNubError);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/index.js
// module id = 426
// module chunks = 0